export function getFirstYear() {
  // 契約日・工事日・顧客のシステム登録日
  return 2020;
}

export function getOneYear() {
  let date = new Date();
  // 現在の年月を取得
  const thisYear = date.getFullYear();
  const thisMonth = date.getMonth() + 1;
  const thisDay = date.getDate();

  // 11か月前の年月を取得
  date.setMonth(date.getMonth() - 11);
  const lastYear = date.getFullYear();
  const lastMonth = date.getMonth() + 1;
  return { thisYear, thisMonth, thisDay, lastYear, lastMonth };
}

export function getOneYearList() {
  let date = new Date();
  let oneYearList = [];
  // 12か月前の年月を取得
  date.setMonth(date.getMonth() - 12);
  for (let i = 0; i < 12; i++) {
    date.setMonth(date.getMonth() + 1);
    if (i === 0 || date.getMonth() === 0) {
      oneYearList.push(
        date.getFullYear().toString() +
          "年" +
          (date.getMonth() + 1).toString() +
          "月"
      );
    } else {
      oneYearList.push((date.getMonth() + 1).toString() + "月");
    }
  }
  return oneYearList;
}

export function getOneYearListDetail() {
  let date = new Date();
  let oneYearList = [];
  // 12か月前の年月を取得
  date.setMonth(date.getMonth() - 12);
  for (let i = 0; i < 12; i++) {
    date.setMonth(date.getMonth() + 1);
    oneYearList.push(
      date.getFullYear().toString() +
        "年" +
        (date.getMonth() + 1).toString() +
        "月"
    );
  }
  return oneYearList;
}
